export default __webpack_public_path__ + "static/media/CardCompressionRelease.f497e592.svg";